import { render, staticRenderFns } from "./mycustomer.vue?vue&type=template&id=2366a01b&scoped=true"
import script from "./mycustomer.vue?vue&type=script&lang=js"
export * from "./mycustomer.vue?vue&type=script&lang=js"
import style0 from "./mycustomer.vue?vue&type=style&index=0&id=2366a01b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366a01b",
  null
  
)

export default component.exports